// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#total-grid {
  border: 1px solid white;
}

.enableColor {
  color: unset !important;
}

.disableColor {
  color: rgba(0, 0, 0, 0.42) !important;
}

.updateinfo:hover {
  opacity: 0.7 !important;
}

button#memberDone:hover {
  opacity: 0.7 !important;
}

button.button.button-md.button-default.button-default-md.button-full.button-full-md.button-md-light:hover {
  opacity: 0.5 !important;
}

.inputItem {
  color: #000000;
  font-size: 14px;
  background: white;
  border: 2px solid #efefef;
  border-radius: 5px;
  height: 40px;
}

.labelContent {
  position: relative;
  font-size: 14px;
  top: 12px;
  color: white;
  margin: auto;
  padding: 5px;
  float: right;
}

.labelContentMbl {
  position: relative;
  font-size: 14px;
  top: 12px;
  color: white;
  margin: auto;
  padding: 5px;
}

.row {
  padding-top: 12px;
}

.row .log-user {
  padding-top: 0 !important;
}

ion-row.header-row.row {
  padding: 0px !important;
}

.error-text {
  text-align: left;
  font-size: 14px;
  height: 0px;
}

.e-input-group {
  width: 100% !important;
  border-width: 1px 1px 1px 1px !important;
  border: 2px solid #efefef !important;
  border-radius: 5px !important;
  height: 40px !important;
  background: white !important;
}

.e-input-group input.e-input,
.e-input-group input,
.e-input-group.e-control-wrapper input.e-input,
.e-input-group.e-control-wrapper input {
  padding-left: 10px;
  padding-top: 10px;
}

.e-input-group input.e-input:focus,
.e-input-group.e-control-wrapper input.e-input:focus {
  padding-left: 10px;
  padding-top: 10px;
}

.e-input-group.e-control-wrapper .e-input-group-icon:last-child {
  margin-right: 6px !important;
  padding-top: 6px !important;
}

.e-input {
  font-size: 14px;
}

.e-multiselect.e-input-group {
  padding-left: 10px !important;
}

span.e-searcher {
  padding-top: 3px;
}

.maskinput {
  font-size: 14px !important;
  width: 100%;
  letter-spacing: 1px;
  padding-left: 0px !important;
  background: #fff !important;
  font-family: "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif";
  font-weight: normal !important;
  color: black;
}

.text-input {
  margin: 10px 8px !important;
}

li {
  color: white;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.updateinfo {
  width: 100%;
  height: 40px;
  background-color: #be1e2d;
  color: white;
  font-size: 14px;
  border-radius: 5px;
}

@media only screen and (max-width: 500px) {
  .label-text {
    text-align: left !important;
  }
  #total-grid {
    width: 100% !important;
  }
  .row {
    padding-top: 0px !important;
  }
  .labelContent {
    top: 9px !important;
  }
  .removableCol {
    display: none !important;
  }
}
.footer {
  text-align: center;
  font-size: 11px;
  font-style: italic;
  color: white;
  background: #be1e2d;
}

.header-row {
  padding-top: �0px� !important;
}

@media only screen and (max-width: 768px) {
  #total-grid {
    border: 1px solid transparent;
  }
}
.account-grid {
  margin-top: calc(80px + env(safe-area-inset-top)) !important;
  padding: 20px !important;
  margin-bottom: 30px;
  border: 1px solid white;
}

.cancel-btn {
  height: 42px;
  opacity: 0.7;
  width: 100%;
  background-color: #f4f4f4;
  color: black;
  margin-top: 15px;
  font-size: 14px;
}

.submit-btn {
  color: #ffffff;
  font-size: 14px;
  background: #be1e2d;
  height: 42px;
  width: 100%;
  margin-top: 15px;
}

ion-select {
  opacity: 1;
}

::ng-deep .account-popover {
  --width: 235px;
  height: 90%;
}
::ng-deep .account-popover .popover-viewport.sc-ion-popover-md {
  overflow-y: auto;
}
::ng-deep .account-popover .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .account-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .account-popover ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .account-popover ion-item ion-radio {
  --color-checked: #be1e2d !important;
}
::ng-deep .account-popover .popover-content {
  border-radius: 7px !important;
}

.e-disabled {
  opacity: 1;
}

input.maskinput:focus {
  border: none;
  outline-width: 0;
  outline: 0;
}

.numberMask:disabled {
  font-size: 14px !important;
  width: 100%;
  letter-spacing: 1px;
  padding-left: 8px !important;
  background: #fff !important;
  font-family: "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif";
  font-weight: normal !important;
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}

.numberMask {
  padding-left: 8px !important;
}

#athletePhoneNumber {
  padding: 7px;
  font-size: 14px;
}

#parentPhoneNumber {
  padding: 7px;
  font-size: 14px;
}

::ng-deep .account-popovermobile {
  --width: 92%;
  transform-origin: right top !important;
  left: 18px;
}
::ng-deep .account-popovermobile .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .account-popovermobile ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .account-popovermobile ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .account-popovermobile ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

@media only screen and (max-width: 500px) {
  .account-grid {
    width: 100% !important;
  }
  ::ng-deep .account-popovermobile {
    --width: 90%;
  }
}
@media only screen and (max-width: 450px) {
  ::ng-deep .account-popovermobile {
    --width: 92%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/account-settings/account-settings.page.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,uBAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,qCAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAEJ;;AACA;EACI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;AAEJ;;AACA;EACI,sBAAA;EACA,wCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,4BAAA;AAEJ;;AACA;;;;EAII,kBAAA;EACA,iBAAA;AAEJ;;AACA;;EAEI,kBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,4BAAA;EACA,2BAAA;AAEJ;;AACA;EACI,eAAA;AAEJ;;AACA;EACI,6BAAA;AAEJ;;AACA;EACI,gBAAA;AAEJ;;AACA;EACI,0BAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2EAAA;EACA,8BAAA;EACA,YAAA;AAEJ;;AACA;EACI,2BAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;;EAEI,wBAAA;EACA,SAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAEJ;;AACA;EACI;IACI,2BAAA;EAEN;EACE;IACI,sBAAA;EACN;EAEE;IACI,2BAAA;EAAN;EAGE;IACI,mBAAA;EADN;EAIE;IACI,wBAAA;EAFN;AACF;AAKA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,6BAAA;AAHJ;;AAMA;EACI;IACI,6BAAA;EAHN;AACF;AAMA;EACI,4DAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,UAAA;AAJJ;;AAOA;EAEI,cAAA;EACA,WAAA;AALJ;AAOI;EACI,gBAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAPR;AASQ;EACI,yBAAA;EACA,2BAAA;AAPZ;AAUQ;EACI,mCAAA;AARZ;AAYI;EACI,6BAAA;AAVR;;AAcA;EACI,UAAA;AAXJ;;AAcA;EACI,YAAA;EACA,gBAAA;EACA,UAAA;AAXJ;;AAcA;EACI,0BAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2EAAA;EACA,8BAAA;EACA,yBAAA;EACA,UAAA;AAXJ;;AAcA;EACI,4BAAA;AAXJ;;AAcA;EACI,YAAA;EACA,eAAA;AAXJ;;AAcA;EACI,YAAA;EACA,eAAA;AAXJ;;AAcA;EACI,YAAA;EACA,sCAAA;EACA,UAAA;AAXJ;AAYK;EACG,gBAAA;AAVR;AAYI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAVR;AAWQ;EACI,yBAAA;EACA,2BAAA;AATZ;AAWQ;EACI,iCAAA;AATZ;;AAcA;EACI;IACI,sBAAA;EAXN;EAcE;IACI,YAAA;EAZN;AACF;AAgBA;EACI;IACI,YAAA;EAdN;AACF","sourcesContent":["#total-grid {\n    border: 1px solid white;\n}\n\n.enableColor {\n    color: unset !important;\n}\n\n.disableColor {\n    color: rgba(0, 0, 0, 0.42) !important;\n}\n\n.updateinfo:hover {\n    opacity: 0.7 !important;\n}\n\nbutton#memberDone:hover {\n    opacity: 0.7 !important;\n}\n\nbutton.button.button-md.button-default.button-default-md.button-full.button-full-md.button-md-light:hover {\n    opacity: 0.5 !important;\n}\n\n.inputItem {\n    color: #000000;\n    font-size: 14px;\n    background: white;\n    border: 2px solid #efefef;\n    border-radius: 5px;\n    height: 40px;\n}\n\n.labelContent {\n    position: relative;\n    font-size: 14px;\n    top: 12px;\n    color: white;\n    margin: auto;\n    padding: 5px;\n    float: right;\n}\n\n.labelContentMbl{\n    position: relative;\n    font-size: 14px;\n    top: 12px;\n    color: white;\n    margin: auto;\n    padding: 5px;\n}\n\n.row {\n    padding-top: 12px;\n}\n\n.row .log-user {\n    padding-top: 0 !important;\n}\n\nion-row.header-row.row {\n    padding: 0px !important;\n}\n\n.error-text {\n    text-align: left;\n    font-size: 14px;\n    height: 0px;\n}\n\n.e-input-group {\n    width: 100% !important;\n    border-width: 1px 1px 1px 1px !important;\n    border: 2px solid #efefef !important;\n    border-radius: 5px !important;\n    height: 40px !important;\n    background: white !important;\n}\n\n.e-input-group input.e-input,\n.e-input-group input,\n.e-input-group.e-control-wrapper input.e-input,\n.e-input-group.e-control-wrapper input {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group input.e-input:focus,\n.e-input-group.e-control-wrapper input.e-input:focus {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group.e-control-wrapper .e-input-group-icon:last-child {\n    margin-right: 6px !important;\n    padding-top: 6px !important;\n}\n\n.e-input {\n    font-size: 14px;\n}\n\n.e-multiselect.e-input-group {\n    padding-left: 10px !important;\n}\n\nspan.e-searcher {\n    padding-top: 3px;\n}\n\n.maskinput {\n    font-size: 14px !important;\n    width: 100%;\n    letter-spacing: 1px;\n    padding-left: 0px !important;\n    background: #fff !important;\n    font-family: \"Roboto\", \"Segoe UI\", \"GeezaPro\", \"DejaVu Serif\", \"sans-serif\";\n    font-weight: normal !important;\n    color: black;\n}\n\n.text-input {\n    margin: 10px 8px !important;\n}\n\nli {\n    color: white;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.updateinfo {\n    width: 100%;\n    height: 40px;\n    background-color: #be1e2d;\n    color: white;\n    font-size: 14px;\n    border-radius: 5px;\n}\n\n@media only screen and (max-width: 500px) {\n    .label-text {\n        text-align: left !important;\n    }\n\n    #total-grid {\n        width: 100% !important;\n    }\n\n    .row {\n        padding-top: 0px !important;\n    }\n\n    .labelContent {\n        top: 9px !important;\n    }\n\n    .removableCol {\n        display: none !important;\n    }\n}\n\n.footer {\n    text-align: center;\n    font-size: 11px;\n    font-style: italic;\n    color: white;\n    background: #be1e2d;\n}\n\n.header-row {\n    padding-top: �0px� !important;\n}\n\n@media only screen and (max-width: 768px) {\n    #total-grid {\n        border: 1px solid transparent;\n    }\n}\n\n.account-grid {\n    margin-top: calc(80px + env(safe-area-inset-top)) !important;\n    padding: 20px !important;\n    margin-bottom: 30px;\n    border: 1px solid white;\n}\n\n.cancel-btn {\n    height: 42px;\n    opacity: 0.7;\n    width: 100%;\n    background-color: #f4f4f4;\n    color: black;\n    margin-top: 15px;\n    font-size: 14px;\n}\n\n.submit-btn {\n    color: #ffffff;\n    font-size: 14px;\n    background: #be1e2d;\n    height: 42px;\n    width: 100%;\n    margin-top: 15px;\n}\n\nion-select {\n    opacity: 1;\n}\n\n::ng-deep .account-popover {\n\n    --width: 235px;\n    height: 90%;\n\n    .popover-viewport.sc-ion-popover-md {\n        overflow-y: auto;\n    }\n\n    .popover-viewport.sc-ion-popover-ios {\n        overflow-y: auto;\n    }\n\n    ion-item {\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label {\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n\n        ion-radio {\n            --color-checked: #be1e2d !important;\n        }\n    }\n\n    .popover-content{\n        border-radius: 7px !important;\n    }\n}\n\n.e-disabled {\n    opacity: 1.0;\n}\n\ninput.maskinput:focus {\n    border: none;\n    outline-width: 0;\n    outline: 0;\n}\n\n.numberMask:disabled {\n    font-size: 14px !important;\n    width: 100%;\n    letter-spacing: 1px;\n    padding-left: 8px !important;\n    background: #fff !important;\n    font-family: \"Roboto\", \"Segoe UI\", \"GeezaPro\", \"DejaVu Serif\", \"sans-serif\";\n    font-weight: normal !important;\n    color: rgba(0, 0, 0, 0.4);\n    opacity: 1.0;\n}\n\n.numberMask {\n    padding-left: 8px !important;\n}\n\n#athletePhoneNumber {\n    padding: 7px;\n    font-size: 14px;\n}\n\n#parentPhoneNumber {\n    padding: 7px;\n    font-size: 14px;\n}\n\n::ng-deep .account-popovermobile {\n    --width: 92%;\n    transform-origin: right top !important;\n    left: 18px;\n     .popover-viewport.sc-ion-popover-ios {\n        overflow-y: auto; \n    }\n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n        ion-label{\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    } \n}\n\n@media only screen and (max-width: 500px){\n    .account-grid{\n        width: 100% !important;\n    }\n    \n    ::ng-deep .account-popovermobile{\n        --width: 90%;\n    }\n\n}\n\n@media only screen and (max-width: 450px) {\n    ::ng-deep .account-popovermobile{\n        --width: 92%;\n    }\n}\n    \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
